export const RankColor = [
  {
    level: "newbie",
    color: "text-newbie-400",
  },
  {
    level: "pupil",
    color: "text-pupil-400",
  },
  {
    level: "specialist",
    color: "text-specialist-400",
  },
  {
    level: "expert",
    color: "text-expert-400",
  },
  {
    level: "candidate master",
    color: "text-cm-400",
  },
  {
    level: "master",
    color: "text-master-400",
  },
  {
    level: "international master",
    color: "text-im-400",
  },
  {
    level: "grandmaster",
    color: "text-gm-400",
  },
  {
    level: "international grandmaster",
    color: "text-igm-400",
  },
  {
    level: "legendary grandmaster",
    color: "text-lgm-400",
  },
];
